module.exports = __webpack_public_path__ + "ae618cd10131ad2cd5937db9f98dd0fa.svg";